module.exports = {
  "version": "0.26.1"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 56
// module chunks = 0